import { disputeEvidence, DisputeEvidence, disputeReason, DisputeReason } from './customer-order-disputes-model'

export const DefaultRecommendedEvidence = [
  disputeEvidence.uncategorizedText,
  disputeEvidence.uncategorizedFile
] as DisputeEvidence[]

/**
 * @link https://docs.stripe.com/disputes/categories#dispute-category-types
 */
export const RecommendedEvidenceByReasonMap = {
  [disputeReason['credit_not_processed']]: [
    disputeEvidence.cancellationPolicy,
    disputeEvidence.refundPolicy,
    disputeEvidence.cancellationPolicyDisclosure,
    disputeEvidence.refundPolicyDisclosure,
    disputeEvidence.cancellationRebuttal,
    disputeEvidence.refundRefusalExplanation,
    disputeEvidence.customerCommunication,
    disputeEvidence.uncategorizedText,
    disputeEvidence.uncategorizedFile
  ],
  [disputeReason['duplicate']]: [
    // disputeEvidence.duplicateChargeId,
    // disputeEvidence.duplicateChargeExplanation,
    disputeEvidence.duplicateChargeDocumentation,
    disputeEvidence.serviceDocumentation,
    disputeEvidence.customerCommunication,
    disputeEvidence.uncategorizedText,
    disputeEvidence.uncategorizedFile
  ],
  [disputeReason['fraudulent']]: [
    disputeEvidence.serviceDate,
    disputeEvidence.serviceDocumentation,
    disputeEvidence.customerCommunication,
    disputeEvidence.customerSignature,
    disputeEvidence.uncategorizedText,
    disputeEvidence.uncategorizedFile
  ],
  [disputeReason['unrecognized']]: [
    disputeEvidence.serviceDate,
    disputeEvidence.serviceDocumentation,
    disputeEvidence.customerCommunication,
    disputeEvidence.customerSignature,
    disputeEvidence.uncategorizedText,
    disputeEvidence.uncategorizedFile
  ],
  [disputeReason['product_not_received']]: [
    disputeEvidence.serviceDate,
    disputeEvidence.serviceDocumentation,
    disputeEvidence.customerCommunication,
    disputeEvidence.customerSignature,
    disputeEvidence.shippingDate,
    disputeEvidence.shippingDocumentation,
    disputeEvidence.shippingTrackingNumber,
    disputeEvidence.uncategorizedFile,
    disputeEvidence.uncategorizedText
  ],
  [disputeReason['product_unacceptable']]: [
    disputeEvidence.productDescription,
    disputeEvidence.customerCommunication,
    disputeEvidence.refundPolicy,
    disputeEvidence.refundPolicyDisclosure,
    disputeEvidence.uncategorizedText,
    disputeEvidence.uncategorizedFile
  ]
  // Uncomment additional mappings as needed
  // [disputeReason['general']]: [
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.uncategorizedFile,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['subscription_canceled']]: [
  //   disputeEvidence.cancellationPolicy,
  //   disputeEvidence.cancellationPolicyDisclosure,
  //   disputeEvidence.cancellationRebuttal,
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.uncategorizedFile,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['bank_cannot_process']]: [
  //   disputeEvidence.serviceDate,
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.serviceDocumentation,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['debit_not_authorized']]: [
  //   disputeEvidence.serviceDate,
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.serviceDocumentation,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['incorrect_account_details']]: [
  //   disputeEvidence.serviceDate,
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.serviceDocumentation,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['insufficient_funds']]: [
  //   disputeEvidence.serviceDate,
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.serviceDocumentation,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['check_returned']]: [
  //   disputeEvidence.customerCommunication,
  //   disputeEvidence.uncategorizedFile,
  //   disputeEvidence.uncategorizedText
  // ],
  // [disputeReason['customer_initiated']]: [
  //   disputeEvidence.uncategorizedFile,
  //   disputeEvidence.uncategorizedText
  // ]
} as Record<DisputeReason, DisputeEvidence[]>
